import { useDispatch, useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
 
import {
  PaymentForm,
  PaymentPage, PaymentResult, 
} from "./index";  

const AppRoutes = () => { 
 
    return (
      <Routes >
        <Route path="/" element={<PaymentPage />} /> 
        <Route path="/odeme-sonuc" element={<PaymentResult />} /> 
        <Route path="/odeme-formu" element={<PaymentForm />} /> 
      </Routes>
    ); 
};





function Layout(props) {
  return (

    <div>
          <div className="m-0 p-0 bg-white"> 
              <div className="flex  w-full"> 
                <main className={"w-full"} >
                  {/* {AppRoutes()} */}
                  <PaymentForm />
                </main>
              </div> 
          </div> 
      <ToastContainer />
    </div>
  );
}
export default Layout;